import { render } from "./MenuMain.vue?vue&type=template&id=0b8aba17&scoped=true"
import script from "./MenuMain.vue?vue&type=script&lang=js"
export * from "./MenuMain.vue?vue&type=script&lang=js"

import "./MenuMain.vue?vue&type=style&index=0&id=0b8aba17&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8aba17"]])

export default __exports__